import axios from "axios"
import { baseUrlPostGres } from "../constant"
import { apiHeader } from "./ApiHeader"
import { IS_LOADING, STATE_LIST_SUCCESS, STATE_LIST_ERROR, STATE_UPDATE_SUCCESS, STATE_UPDATE_ERROR } from "./Type"
import { apiVersion } from "src/utils/apiVersion"

export const getAllContactUsLsts = (page,size) => async (dispatch) => {
    dispatch({ type: IS_LOADING })
    await axios
        .get(`${baseUrlPostGres()}/admin/${apiVersion.v1}/contactus/get_all_contact_us_requests?page=${page}&size=${size}`, {
            headers: apiHeader()
        })
        .then(response => {
            dispatch({
                type: STATE_LIST_SUCCESS,
                payload: response
            })
        })
        .catch(errors => {
            dispatch({
                type: STATE_LIST_ERROR,
                payload: errors
            })
            console.log("user list error", errors);
        })
}
